import { EquipmentCategory } from 'components/structure-page/modals/add-equipment-modal-config';
import { ExistingSystemType } from 'data/types';
import { existingSystemAcceptsComponentKind } from 'utils/existing-equipment';

export type ExistingEquipmentAddButton = {
  kind: EquipmentCategory;
  label: string;
  description?: string;
};

export const PACKAGED_TILE_DISABLED_REASON =
  'A packaged unit is a complete system on its own — add it to a new system instead.';

export const SPLIT_TILE_DISABLED_REASON =
  'This system holds a packaged unit, which cannot share components — add split equipment to a new system instead.';

export function existingEquipmentAddButtonDisabledReason(
  system: ExistingSystemType | null,
  kind: EquipmentCategory
): string | null {
  if (!system) return null;
  const isSelfContained = kind === 'packaged-unit';
  if (existingSystemAcceptsComponentKind(system, isSelfContained)) return null;
  return isSelfContained
    ? PACKAGED_TILE_DISABLED_REASON
    : SPLIT_TILE_DISABLED_REASON;
}

export const EXISTING_EQUIPMENT_ADD_BUTTONS: ExistingEquipmentAddButton[] = [
  {
    kind: 'outdoor-unit',
    label: 'Outdoor Unit',
    description: 'Condenser / heat pump'
  },
  {
    kind: 'indoor-unit',
    label: 'Indoor Unit',
    description: 'Evaporator coil / air handler'
  },
  {
    kind: 'blower-unit',
    label: 'Blower Unit',
    description: 'Furnace / modular blower'
  },
  {
    kind: 'packaged-unit',
    label: 'Packaged Unit',
    description: 'Self-contained AC, heat pump, or gas pack'
  }
];
